import { times } from "lodash-es"
import { JourneyCardSkeleton } from "../JourneyCard"
import { JourneyCardBlock } from "./JourneyProducts"
import s from "./JourneyProducts.module.scss"

export const JourneyProductsSkeleton = () => {
  return (
    <div className={s.products}>
      {times(6, (index) => (
        <JourneyCardBlock key={index}>
          <JourneyCardSkeleton />
        </JourneyCardBlock>
      ))}
    </div>
  )
}
